<template>
  <qx-card title="子卡账户明细列表">
    <section slot="titleLeft">
      <qx-permpisions permpisions>
        <section slot="titleLeft">
          <!-- 【金额合计：
          <span class="primary">123.00</span>
          】-->
        </section>
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <!-- 表格 -->
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <!-- 选择框 -->
          <!-- <el-table-column type="selection" width="55" /> -->
          <!-- 选择框 end -->
          <!-- 常规列表项 -->
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            :fixed="item.prop === 'oilMasterCardNum'"
          ></el-table-column>
          <!-- 常规列表项 end -->
        </el-table>
      </section>
      <!-- 表格 end -->
      <!-- 分页 -->
      <section class="paginationBox clearPa">
        <!-- 分页组件 -->
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
        <!-- 分页组件 end -->
      </section>
      <!-- 分页 end -->
    </section>
  </qx-card>
</template>

<script>
import tableMixin from '@qx/mixin/table';
import {
  queryOilDaughterCardAccountDetailsList,
} from 'api/service';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            // prop: 'oilDaughterCardNum',
            prop: 'oilCardNum',
            label: '子卡卡号',
          },
          {
            prop: 'plateNumber',
            label: '车牌号',
          },
          {
            prop: 'operationTypeName',
            label: '操作类型',
          },
          {
            prop: 'operationTime',
            label: '操作时间',
          },
          {
            prop: 'amount',
            label: '金额',
          },
          {
            prop: 'oilCardTypeName',
            label: '主卡类型',
          },
          {
            prop: 'serviceName',
            label: '服务商',
          },
          // {
          //   prop: 'oilMasterCardNum',
          //   label: '主卡卡号',
          // },
          {
            prop: 'orderId',
            label: '订单号',
          },
          {
            prop: 'customerName',
            label: '客户名称',
          },
          {
            prop: 'sourceName',
            label: '线路名称',
          },
          {
            prop: 'dependTime',
            label: '订单发车时间',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: queryOilDaughterCardAccountDetailsList,
  },
};
</script>

<style lang="scss" scoped>
</style>
